import { Box } from "@mui/material";
import { memo } from "react";

export const gridTemplateColumns = "60px minmax(150px, 2fr) 1fr 1fr 0.6fr 0.8fr 1fr 1fr 40px";

const headerTextStyle = { fontSize: "0.8rem", fontWeight: 600, color: "#fff" };

const ProductTableHeader = memo(function ProductTableHeader() {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns,
        gap: 2,
        px: 2,
        py: 1.5,
        backgroundColor: "#344767",
        borderRadius: "4px 4px 0 0",
        mb: 0,
        alignItems: "center",
      }}
    >
      <Box component="span" sx={headerTextStyle}>
        Optional
      </Box>
      <Box component="span" sx={headerTextStyle}>
        Product Name
      </Box>
      <Box component="span" sx={{ ...headerTextStyle, ml: "-6px" }}>
        Cost
      </Box>
      <Box component="span" sx={{ ...headerTextStyle, ml: "-7px" }}>
        Profit
      </Box>
      <Box component="span" sx={{ ...headerTextStyle, ml: "-10px" }}>
        Margin
      </Box>
      <Box component="span" sx={{ ...headerTextStyle, ml: "-11px" }}>
        Discount
      </Box>
      <Box component="span" sx={{ ...headerTextStyle, ml: "-12px" }}>
        Total
      </Box>
      <Box component="span" sx={{ ...headerTextStyle, ml: "-13px" }}>
        Unit Price
      </Box>
      <Box />
    </Box>
  );
});

export default ProductTableHeader;
